/**
 * Richtext Wrapper
 *
 * @selector .richtextWrapper
 * @enabled true
 */

import BaseModule from '../../modules/BaseModule.js';
import fastdom from 'fastdom';

export default class RichtextWrapper extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$title = this.$el.find('h2').eq(0);

        this.syncMinHeight();
        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on(window, 'resize', this.onWindowResize);
    }

    onWindowResize() {
        this.syncMinHeight();
    }

    syncMinHeight() {
        fastdom.measure(() => {
            this.height = this.$title.height();
        });

        fastdom.mutate(() => {
            this.el.style.setProperty('--min-height', `${this.height}px`);
        });
    }
}
